import React, { useEffect } from "react";
import "./global.css";
import AOS from "aos";
import "aos/dist/aos.css";
import "../assets/home-css/responsive.css";
import "../assets/home-css/style.css";
import { Link } from "react-router-dom";
import Footer from "../components/Footer/Footer";
import CountDown from "../components/Counter/CountDown";

function LandingPage() {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);
  return (
    <div className="body_06">
      <header id="header-06" className="header resp">
        {/* START NAVBAR */}
        <nav
          className="navbar navbar-expand-md navbar-light bg-faded cripto_nav navbar-head"
          style={{ padding: 0 }}
        >
          <div className="container">
            <button
              className="navbar-toggler navbar-toggler-right"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <i className="fas fa-bars" />
            </button>
            <a className="navbar-brand" data-scroll href="index.html">
              <span className="logo-heading" style={{ fontWeight: 600 }}>
                <img
                  src="/home-asset/images/Untitled-5(2).png"
                  className="logo-main"
                />
              </span>
            </a>
            <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent"
            >
              <ul
                className="navbar-nav ml-auto nav-ul"
                style={{ width: "100%" }}
              >
                <li className="nav-item">
                  <a data-scroll href="#header-06" className="nav-link active">
                    Home
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    data-scroll
                    href="#welcome_cryptonic_06"
                    className="nav-link"
                  >
                    About
                  </a>
                </li>
                <li className="nav-item">
                  <a data-scroll href="#ecosystem" className="nav-link">
                    Ecosystem
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    data-scroll
                    href="#token_distribution_06"
                    className="nav-link"
                  >
                    Tokenomics
                  </a>
                </li>
                <li className="nav-item">
                  <a data-scroll href="#roadmap_06" className="nav-link">
                    Roadmap
                  </a>
                </li>
                {/* <li class="nav-item"><a data-scroll href="#team_membar_06" class="nav-link">Team</a></li>                     */}
                <li className="nav-item" style={{ textAlign: "center" }}>
                  <a data-scroll href="#faq-area-06" className="nav-link">
                    Faq
                  </a>
                </li>
                <li className="nav-item" style={{ textAlign: "center" }}>
                  <a
                    data-scroll
                    href="/blockagent-ai.pdf"
                    className="nav-link"
                    target="_blank"
                  >
                    Plan PDF
                  </a>
                </li>
                {/* <li class="nav-item" style="text-align: center;">
        <button class="" data-scroll href="#faq-area-06" class="nav-link">Faq</button>
      </li> */}
                {/* <li class="nav-item">                    <div class="language">
                <a href="#" class="token login-btn">Login</a>
            </div></li> */}
                {/* <li class="nav-item"><a data-scroll href="#contact_06" class="nav-link">Contact</a></li> */}
              </ul>
            </div>
          </div>
        </nav>
        {/* END NAVBAR */}
        <div className="container">
          <div className="row">
            <div className="col-xl-6 col-sm-12">
              <div className="intro-text" style={{ textAlign: "left" }}>
                <h1>
                  <span className="logo-heading">BLOCKAGENT:</span>
                  Pioneering Web3 AI tools for blockchain monitoring, security,
                  and next-gen digital asset mining.
                </h1>
                <p>
                  Empowering the Future of Blockchain with AI-Driven Security
                  and Advanced Mining Solutions
                </p>
                <div className="btn_video_wrapper">
                  <Link
                    to="/login"
                    className="btn btn-default btn-default-style"
                  >
                    Login
                  </Link>
                </div>
                <div className="countdown_time" style={{ display: "none" }}>
                  {/* <h3>ICO End in</h3>
                <div class="clock-countdown">
                    <div class="site-config" data-date="12/11/2020 00:00:00" data-date-timezone="+0"></div>
                    <div class="coundown-timer d-flex justify-content-center">
                        <div class="single-counter  d-flex flex-column"><h4><span class="days count-time gradient-color" >00</span></h4><span class="normal">Days</span></div>
                        <div class="single-counter  d-flex flex-column"><h4><span class="hours count-time gradient-color">00</span></h4><span class="normal">Hours</span></div>
                        <div class="single-counter  d-flex flex-column"><h4><span class="minutes count-time gradient-color">00</span></h4><span class="normal">Minutes</span></div>
                        <div class="single-counter  d-flex flex-column"><h4><span class="seconds count-time gradient-color">00</span></h4><span class="normal">Seconds</span></div>
                    </div>
                </div> 
                <div class="count-time_btn">
                    <a href="#" title="" class="gradient-color"><span>Sign up & Join our sale List</span></a> 
                </div> */}
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-sm-12 img-wrapper">
              <div className="intro-img">
                <div className="bounce_wrapper">
                  <img src="/home-asset/images/Asset 1 (1).png" alt />
                  <div className="shape-1" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <span className="shape1 header-shape">
          <img src="/home-asset/images/shape/home_6/header6_shape_1.png" alt />
        </span>
        <span className="shape2 header-shape">
          <img src="/home-asset/images/shape/home_6/header6_shape_2.png" alt />
        </span>
        <span className="shape3 header-shape">
          <img src="/home-asset/images/shape/home_6/header6_shape_3.png" alt />
        </span>
        <span className="shape4 header-shape">
          <img src="/home-asset/images/shape/home_6/header6_shape_4.png" alt />
        </span>
        <span className="shape5 header-shape">
          <img src="/home-asset/images/shape/home_6/header6_shape_5.png" alt />
        </span>
        <span className="shape6 header-shape">
          <img src="/home-asset/images/shape/home_6/header6_shape_6.png" alt />
        </span>
        <span className="bubble1 header-shape">
          <img src="/home-asset/images/particals_icon/fixed1.png" alt />
        </span>
        <span className="bubble2 header-shape">
          <img src="/home-asset/images/particals_icon/fixed1.png" alt />
        </span>
        <span className="bubble3 header-shape">
          <img src="/home-asset/images/particals_icon/fixed2.png" alt />
        </span>
        <span className="bubble4 header-shape">
          <img src="/home-asset/images/particals_icon/fixed4.png" alt />
        </span>
      </header>
      {/* <CountDown /> */}
      <section id="welcome_cryptonic_06">
        <div className="container">
          <div className="row">
            <div className="col-xl-12 col-sm-12">
              <div>
                <h2 className="wow text-white">
                  Welcome to <span className="logo-heading">BlockAgent</span>
                </h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12  mx-auto">
              <div className="about_cryptonic-content">
                <img
                  src={require("../assets/xblock-animation.gif")}
                  alt
                  className="wow ZoomInUp logo-about"
                />
                <p
                //   className="wow fadeInUp"
                //   data-aos="fade-up"
                //   data-aos-duration="1000"
                >
                  <div className="py-4">
                    <h2 className="text-primary">ABOUT BLOCKAGENT</h2>
                    <p className="lead">
                      BlockAgent is UK-based International Company who explore
                      the AI world with AiAgents. BlockAgent world first fintech
                      team who create web3 Ai Tools to monitor Blockchain
                      Activity. BlockAgent is the new era of the crypto & AI
                      mining
                    </p>

                    <ul
                      className="list-unstyled text-start mt-3"
                      style={{
                        marginLeft: "50px",
                      }}
                    >
                      <li>
                        ✦ <strong>BlockAgent</strong> isn't just a company; it's
                        a movement into the new era of crypto and AI mining.
                      </li>
                      <li>
                        ✦ <strong>BlockAgent</strong> proudly stand as the
                        world’s first fintech team to develop Web3 AI tools
                      </li>
                      <li>
                        ✦ With <strong>The BlockAgent</strong>, you don’t just
                        adapt to the future—you shape it.
                      </li>
                    </ul>
                  </div>
                </p>
              </div>
            </div>
          </div>
        </div>
        <span className="shape1 header-shape">
          <img src="/home-asset/images/shape/home_6/wel-map.png" alt />
        </span>
        <span className="bubble1 header-shape">
          <img src="/home-asset/images/particals_icon/fixed1.png" alt />
        </span>
        <span className="bubble2 header-shape">
          <img src="/home-asset/images/particals_icon/fixed1.png" alt />
        </span>
      </section>

      <section id="about_cryptonic_06">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-7 col-lg-5 padding-none">
              <div className="about_cryptonic-content">
                <h2
                  className="wow fadeInUp"
                  data-aos="fade-up"
                  data-aos-duration="600"
                >
                  <span className="logo-heading">BlockAgent: </span> Mission and
                  Vision
                </h2>
                <p
                //   className="wow fadeInUp"
                //   data-aos="fade-up"
                //   data-aos-duration="1000"
                >
                  At BLOCKAGENT, we see a future where cryptocurrencies are
                  accessible to all. Our mission is simple: to democratize
                  access to cryptocurrency rewards. We strive to break down
                  barriers, promote financial literacy, and create an inclusive
                  ecosystem that rewards participation and innovation. We aim to
                  provide a user-friendly platform that enables individuals to
                  earn, learn, and grow within the ever-evolving crypto
                  landscape, envisioning a world where anyone can participate in
                  the digital economy and reap its benefits.
                </p>
                {/* <p class="wow fadeInUp" data-animate="fadeInUp" data-delay="0.4s">
        Due to the use of large computing power and artificial based on
        the neural network, the NRM assistant will instantly analyze
        user data and offer solutions for their further use.
      </p> */}
                {/* <a href="#" class="btn btn-default btn-default-style wow fadeInUp" data-animate="fadeInUp" data-delay="0.5s">Download Whitepaper</a> */}
              </div>
            </div>
            <div className="col-sm-12 col-md-5 col-lg-7">
              <div className="">
                <div className="">
                  <img
                    className="img-rotate"
                    src="/img/Picture7.png"
                    alt
                    data-animate=""
                    data-delay=".3s"
                  />
                  <br />
                  <img
                    className="img-static"
                    src="/img/Picture8.png"
                    alt
                    data-animate=""
                    data-delay=".3s"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <span className="shape1 header-shape">
          <img src="/home-asset/images/shape/home_6/about-light-1.png" alt />
        </span>
        <span className="shape2 header-shape">
          <img src="/home-asset/images/shape/home_6/about-light-2.png" alt />
        </span>
        <span className="bubble1 header-shape">
          <img src="/home-asset/images/particals_icon/fixed1.png" alt />
        </span>
        <span className="bubble2 header-shape">
          <img src="/home-asset/images/particals_icon/fixed2.png" alt />
        </span>
        <span className="bubble3 header-shape">
          <img src="/home-asset/images/particals_icon/fixed3.png" alt />
        </span>
      </section>

      <section id="best_feature_06" style={{ marginTop: "70px" }}>
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div className="sub-title text-white">
                <h6>How it Works</h6>
                <h2>Best Features</h2>
                <p>
                  BlockAgent pioneers Web3 AI tools, revolutionizing blockchain
                  monitoring, security, and AI-driven crypto mining.
                </p>
              </div>
            </div>
          </div>
          <div className="row feature_items d-flex justify-content-between">
            <div className="col-sm-12 col-xl-4 single-wrapper">
              <div
                className="single-items wow fadeInUp"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                <h3>Interoperability</h3>
                <img src="/home-asset/images/icons/feature-01.png" alt />
                <p>
                  Blockchain networks enable seamless cross-platform
                  communication and data sharing through interoperability.
                </p>
              </div>
            </div>
            <div className="col-sm-12 col-xl-4 single-wrapper">
              <div
                className="single-items wow fadeInUp"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                <h3>Secure Transactions</h3>
                <img src="/home-asset/images/icons/feature-02.png" alt />
                <p>
                  Enjoy the peace of mind that comes with top-tier security
                  measures and advanced encryption for all your transactions.
                </p>
              </div>
            </div>
            <div className="col-sm-12 col-xl-4 single-wrapper">
              <div
                className="single-items wow fadeInUp"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                <h3>Decentralized Platform</h3>
                <img src="/home-asset/images/icons/feature-03.png" alt />
                <p>
                  Trade freely with full control, enhanced security, seamless
                  transactions, and complete privacy on decentralized exchanges.
                </p>
              </div>
            </div>
          </div>
        </div>
        <span className="shape1 header-shape">
          <img src="/home-asset/images/shape/home_6/feature-1.png" alt />
        </span>
      </section>

      <section id="token_sale_06">
        <div className="container" id="ecosystem">
          <div className="row">
            <div className="col-sm-12">
              <div className="sub-title text-white">
                <h6
                //   className="wow fadeInUp"
                //   data-aos="fade-up"
                //   data-aos-duration="1000"
                >
                  360°
                </h6>
                <h2
                //   className="wow fadeInUp"
                //   data-aos="fade-up"
                //   data-aos-duration="1000"
                >
                  ECOSYSTEM
                </h2>
              </div>
            </div>
          </div>
          <div className="row pricing_bottom">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <div className="pricing_list_wrapper">
                <ul
                  className="list-unstyled item_list_1 wow fadeInUp"
                  data-aos="fade-up"
                  data-aos-duration="1000"
                >
                  <li>
                    {/* <h3>Pre-Sale starts</h3>
          <span>07-08-2020</span> */}
                    <img
                      src="/home-asset/images/Asset 1 (3).png"
                      style={{ height: 40 }}
                    />
                  </li>
                  <li>
                    <img
                      src="/home-asset/images/Asset 2 (1).png"
                      style={{ height: 30 }}
                    />
                  </li>
                  <li>
                    <img
                      src="/home-asset/images/Asset 3 (1).png"
                      style={{ height: 40 }}
                    />
                  </li>
                </ul>
                <ul
                  className="list-unstyled item_list_2 wow fadeInUp"
                  data-aos="fade-up"
                  data-aos-duration="1000"
                >
                  <li>
                    <img
                      src="/home-asset/images/Asset 3.png"
                      style={{ height: 45 }}
                    />
                  </li>
                  <li>
                    <img
                      src="/home-asset/images/Asset 4 (1).png"
                      style={{ height: 40 }}
                    />
                  </li>
                  <li>
                    <img
                      src="/home-asset/images/Asset 4.png"
                      style={{ height: 40 }}
                    />
                  </li>
                  <li>
                    <img
                      src="/home-asset/images/Asset 2 (2).png"
                      style={{ height: 45 }}
                    />
                  </li>
                </ul>
                <ul
                  className="list-unstyled item_list_3 wow fadeInUp"
                  data-aos="fade-up"
                  data-aos-duration="1000"
                >
                  <li>
                    <img
                      src="/home-asset/images/Asset 5.png"
                      style={{ height: 40 }}
                    />
                  </li>
                  <li>
                    <img
                      src="/home-asset/images/Asset 6.png"
                      style={{ height: 35 }}
                    />
                  </li>
                  <li>
                    <img
                      src="/home-asset/images/Asset 7.png"
                      style={{ height: 30 }}
                    />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <span className="shape1 header-shape">
          <img src="/home-asset/images/shape/home_6/token_sale.png" alt />
        </span>
        <span className="shape2 header-shape">
          <img src="/home-asset/images/shape/home_6/token_sale_1.png" alt />
        </span>
        <span className="bubble1 header-shape">
          <img src="/home-asset/images/particals_icon/fixed1.png" alt />
        </span>
        <span className="bubble2 header-shape">
          <img src="/home-asset/images/particals_icon/fixed1.png" alt />
        </span>
        <span className="bubble4 header-shape">
          <img src="/home-asset/images/particals_icon/fixed3.png" alt />
        </span>
      </section>

      <section id="token_distribution_06">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div className="sub-title text-white">
                <h6
                //   className="wow fadeInUp"
                //   data-aos="fade-up"
                //   data-aos-duration="1000"
                >
                  BLOCKAI Coin Details
                </h6>
                <h2
                //   className="wow fadeInUp"
                //   data-aos="fade-up"
                //   data-aos-duration="1000"
                >
                  TOKENOMICS
                </h2>
              </div>
            </div>
          </div>
          <img
            src="/home-asset/roadmap.png"
            className="tokenomic-img"
            alt="tokenomics"
          />
          <div className=" py-4 mx-5 ">
            <h2 className="text-primary logo-heading">About BlockAi Coin</h2>
            <ul className="list-unstyled text-start">
              <li className=" mb-1">
                ✦ All the projects in the BlockAgent 360°
              </li>
              <li>✦ Ecosystem are based on BlockAi coin</li>
              <li className=" mb-1">
                ✦ After blockchain live, BlockAi Coin will be used in all the
                projects of the ecosystem
              </li>
              <li className=" mb-1">
                ✦ BlockAgent has its own layer1 blockchain whose native coin is
                BlockAi Coin.
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section id="roadmap_06">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 roadmap-head">
              <div
                className="sub-title text-white"
                style={{ textAlign: "center" }}
              >
                <h2
                //   className="wow fadeInUp"
                //   data-aos="fade-up"
                //   data-aos-duration="1000"
                >
                  <span className="logo-heading">BlockAgent</span> Roadmap
                </h2>
                <p
                //   className="wow fadeInUp"
                //   data-aos="fade-up"
                //   data-aos-duration="1000"
                >
                  Leveraging advanced computing power and AI, BlockAgent swiftly
                  analyzes user data to provide actionable insights and
                  optimized solutions for seamless blockchain integration
                </p>
              </div>
            </div>
          </div>
          <section className="timeline">
            <ul>
              <li>
                <div className="reveal">
                  <p>
                    <phase>
                      2025 <br />
                      1st Quarter
                    </phase>
                    XBlockHub Live <br />
                    Community Building <br />
                    AirDrop Program
                    <br />
                  </p>
                </div>
              </li>
              <li>
                <div className="reveal">
                  <p>
                    <phase>
                      2025 <br />
                      2nd Quarter
                    </phase>
                    Blockchain Events in Newyork Blockchain Live <br />
                    Exchanges Listing <br />
                    BlockAi Coin Mining <br />
                    BlockAi NFTs Launching <br />
                    BlockAi Gamify <br />
                  </p>
                </div>
              </li>
              <li>
                <div className="reveal">
                  <p>
                    <phase>
                      2025 <br />
                      3rd Quarter
                    </phase>
                    Collaborations <br />
                    Blockchain Developments
                    <br />
                  </p>
                </div>
              </li>
              <li>
                <div className="reveal">
                  <p>
                    <phase>
                      2026 <br />
                      1st Quarter
                    </phase>
                    BlockAi Swap <br />
                    BlockAi Ecosystems <br />
                    Use Cash BlockAi Coins <br />
                  </p>
                </div>
              </li>
              <li>
                <div className="reveal">
                  <p>
                    <phase>
                      2026 <br />
                      2nd Quarter
                    </phase>
                    Us Exchange Listing <br />
                    Integration of Block20 <br />
                    Smart Chain &amp; Many More <br />
                  </p>
                </div>
              </li>
            </ul>
          </section>
        </div>
        <span className="shape2 header-shape">
          <img src="/home-asset/images/shape/home_6/road_map_2.png" alt />
        </span>
        <span className="shape3 header-shape">
          <img src="/home-asset/images/shape/home_6/road_map_3.png" alt />
        </span>
      </section>

      <section id="contact_06">
        <div className="container">
          <div className="d-flex justify-content-center align-item-center flex-wrap">
            <div className="col-md-6">
              <div className="contact_form">
                <form action="#">
                  <div className="row">
                    <div className="col-12 col-sm-12 form-group  ">
                      <div className="sub-title">
                        <h2 className="colorGradiant ">Media Partner</h2>
                      </div>
                    </div>
                    <div className="title_caption">
                      <span>
                        Find us across the digital spectrum, check us out, feel
                        the pulse of the BlockAgent project.
                      </span>
                    </div>
                    <div className="sub-title">
                      <h2 className="fs-4 colorGradiant">Powered By</h2>
                    </div>
                  </div>
                  <div
                    className="d-flex justify-content-center gap-5 flex-wrap"
                    style={{ width: "" }}
                  >
                    <img
                      src="/img/Picture1.png"
                      style={{ width: "120px", height: "20px" }}
                    />
                    <img
                      src="/img/Picture2.png"
                      style={{ width: "120px", height: "auto" }}
                    />
                    <img
                      src="/img/Picture3.png"
                      style={{ width: "100px", height: "auto" }}
                    />
                    <img
                      src="/img/Picture4.png"
                      style={{ width: "120px", height: "20px" }}
                    />
                    <img
                      src="/img/Picture5.png"
                      style={{ width: "120px", height: "20px" }}
                    />
                    <img
                      src="/img/Picture6.png"
                      style={{ width: "100px", height: "" }}
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12 col-md-6">
              <div className="address_wrapper">
                <div className="sub-title">
                  <h2
                    className="colorGradiant "
                    data-aos="fade-up"
                    data-aos-duration={1000}
                  >
                    Join The Fastest Growing Community
                  </h2>
                </div>
                <div className="contact-info-wrapper">
                  <div className="contact-info">
                    <div className data-aos="fade-up" data-aos-duration={1000}>
                      <div className="title_caption">
                        <span>
                          You All Are Very Lucky That You Are Getting The
                          Opportunity To Work With A Huge 360° Ecosystem Like
                          BlockAgent.
                        </span>
                      </div>
                    </div>
                    <div
                      className="mt-3"
                      data-aos="fade-up"
                      data-aos-duration={1000}
                    >
                      <div className="title_caption">
                        <span>
                          BlockAgent's Own Layer1 Blockchain, You Are Going To
                          Get Only 2% Of The Total Supply Of Its Own BLOCKAI
                          Coin Such Free, So Don't Miss This Chance.
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="faq-area-06" className="faq-area">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div className="sub-title">
                <h2
                //   className="wow fadeInUp"
                //   data-aos="fade-up"
                //   data-aos-duration="1000"
                >
                  Frequently Asked Questions
                </h2>
                <p
                //   className="wow fadeInUp"
                //   data-aos="fade-up"
                //   data-aos-duration="1000"
                />
              </div>
            </div>
          </div>

          <div className="row mx-1 justify-content-center">
            <div className="col-sm-12 col-xl-6">
              <div
                className="faq-img wow fadeInUp"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                <img
                  src="/home-asset/images/fap-01.png"
                  alt
                  className="img-fluid"
                />
              </div>
            </div>
            <div className="col-sm-12 col-xl-6">
              <div className="faq-wrapper">
                {/*Accordion wrapper*/}
                <div
                  className="panel-group accordion-wrapper"
                  id="accordion"
                  role="tablist"
                  aria-multiselectable="true"
                >
                  <div
                    className="panel accordion-single wow fadeInUp"
                    data-aos="fade-up"
                    data-aos-duration="1000"
                  >
                    <div className="panel-heading" role="tab" id="headingOne">
                      <h4 className="panel-title">
                        <a
                          className="collapsed"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseOne"
                          aria-expanded="false"
                          aria-controls="collapseOne"
                        >
                          What is blockchain technology?
                        </a>
                      </h4>
                    </div>
                    <div
                      id="collapseOne"
                      className="panel-collapse collapse"
                      data-bs-parent="#accordion"
                      role="tabpanel"
                      aria-labelledby="headingOne"
                    >
                      <div className="card-body accordion-content">
                        <p>
                          Blockchain technology is a decentralized digital
                          ledger that securely records transactions across
                          multiple computers. It ensures transparency and data
                          integrity through cryptographic methods, making it
                          resistant to tampering and fraud. This innovative
                          technology enables various applications, from
                          cryptocurrency transactions to supply chain
                          management.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div
                    className="panel accordion-single  fadeInUp"
                    data-aos="fade-up"
                    data-aos-duration="1000"
                  >
                    <div className="panel-heading" role="tab" id="headingTwo">
                      <h4 className="panel-title">
                        <a
                          className="collapsed"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseTwo"
                          aria-expanded="false"
                          aria-controls="collapseTwo"
                        >
                          What is Decentralization?
                        </a>
                      </h4>
                    </div>
                    <div
                      id="collapseTwo"
                      className="panel-collapse collapse"
                      data-bs-parent="#accordion"
                      role="tabpanel"
                      aria-labelledby="headingTwo"
                    >
                      <div className="card-body accordion-content">
                        <p>
                          Decentralization distributes control and data across a
                          network, removing single points of failure and
                          enhancing security and resilience.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div
                    className="panel accordion-single wow fadeInUp"
                    data-aos="fade-up"
                    data-aos-duration="1000"
                  >
                    <div className="panel-heading" role="tab" id="headingThree">
                      <h4 className="panel-title">
                        <a
                          className="collapsed"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseThree"
                          aria-expanded="false"
                          aria-controls="collapseThree"
                        >
                          What are smart contracts?
                        </a>
                      </h4>
                    </div>
                    <div
                      id="collapseThree"
                      className="panel-collapse collapse"
                      data-bs-parent="#accordion"
                      role="tabpanel"
                      aria-labelledby="headingThree"
                    >
                      <div className="card-body accordion-content">
                        <p>
                          Smart contracts are executed on blockchain, which
                          means that the terms are stored in a distributed
                          database and cannot be changed. Transactions are also
                          processed on the blockchain, which automates payments
                          and counterparties.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div
                    className="panel accordion-single wow fadeInUp"
                    data-aos="fade-up"
                    data-aos-duration="1000"
                  >
                    <div className="panel-heading" role="tab" id="headingFour">
                      <h4 className="panel-title">
                        <a
                          className="collapsed"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseFour"
                          aria-expanded="false"
                          aria-controls="collapseFour"
                        >
                          Is BlockAgent secure for buying and selling coins?
                        </a>
                      </h4>
                    </div>
                    <div
                      id="collapseFour"
                      className="panel-collapse collapse"
                      data-bs-parent="#accordion"
                      role="tabpanel"
                      aria-labelledby="headingFour"
                    >
                      <div className="card-body accordion-content">
                        <p>
                          Yes, BlockAgent is built on secure blockchain
                          technology, which uses decentralized networks and
                          cryptographic methods to protect transactions. While
                          blockchain itself is secure, we continuously monitor
                          and update our platform to address any potential
                          risks, ensuring that your coin transactions are safe
                          and secure
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <footer id="footer-06" className="footer">
        <div className="container">
          <div className="row footer-btm-wrapper">
            <div className="col-md-12 col-lg-12">
              <div className="footer_items">
                <div className="footer-div">
                  <div className="footer-cont">
                    <h3
                      className="subtitle_1"
                      style={{ justifySelf: "center", paddingRight: 25 }}
                    >
                      &nbsp;
                      <img
                        src="/home-asset/images/Untitled-5(2).png"
                        className="logo-main"
                        alt
                      />
                    </h3>
                    <ul className="social-links list-unstyled ml-auto mb-4">
                      <li className="nav-item">
                        <a href="#">
                          <i className="fab fa-facebook-f" />
                        </a>
                      </li>
                      <li className="nav-item">
                        <a href="#">
                          <i className="fab fa-twitter" />
                        </a>
                      </li>
                      <li className="nav-item">
                        <a href="#">
                          <i className="fab fa-linkedin-in" />
                        </a>
                      </li>
                      <li className="nav-item">
                        <a href="#">
                          <i className="fab fa-instagram" />
                        </a>
                      </li>
                    </ul>
                    <span className=" mt-5">
                      Support Email: blockgntspprt@gmail.com
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="copyright">
          <p>
            Copyright © 2025, Created by <span>BLOCKAGENT</span>
          </p>
        </div>
      </footer> */}
      <Footer />
    </div>
  );
}

export default LandingPage;
